import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AuthNavigation from './Navigations/Auth/AuthNavigation';
import PagesNavigation from './Navigations/Pages/PagesNavigation';

const { $ } = window;

function App() {
  const darkMode = useSelector(state => state.theme.darkMode);

  useEffect(() => {
    if (darkMode) {
      $(".theme-body-mode").addClass("dark-mode");
    } else {
      $(".theme-body-mode").removeClass("dark-mode");
    }
    console.log('ENV: ', process.env);
  }, [darkMode]);

  const isLoggedIn = useSelector(({ auth: { isLoggedIn } }) => isLoggedIn);
  return isLoggedIn ? <PagesNavigation /> : <AuthNavigation />;
}

export default App;
